import { REPORT_EVENT } from './consts';
export const getReportEvent = (key) => {
    if (window[REPORT_EVENT]) {
        return window[REPORT_EVENT][key];
    }
    return null;
};
